module.exports = __webpack_public_path__ + "3bb581237b6c7e957e91716235ffdc96.jpg";